module.exports = __webpack_public_path__ + "static/media/shish-kebab.dc8c67d0.svg";